import Vue from 'vue'

import {library} from '@fortawesome/fontawesome-svg-core'

import {
  faClock,
  faSortUp,
  faSortDown,
  faInfoCircle,
  faTimes,
  faArrowsAltV,
  faEnvelope,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faLink,
  faUnlink,
  faExclamationTriangle,
  faCheck,

  faAngleLeft,
  faAngleRight,
  faPlusCircle,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCircle,
  faCheckCircle,
  faSquare,
  faCheckSquare,
  faCalendarExclamation,
  faCalendarCheck,
  faCalendarTimes,
  faMinusCircle,
  faSave,
} from '@fortawesome/pro-light-svg-icons'

import {
  faCcVisa,
  faCcStripe,
  faCcMastercard
} from '@fortawesome/free-brands-svg-icons'
// import {
//   faToggleOn,
//   faToggleOff,
//   faEye,
//   faPrint,
//   faCopy,
//   faComments,
//   faTrash,
//   faSignOutAlt,
//   faClone,
//   faUserFriends,
//   faSortAmountDownAlt,
//   faUser,
//   faUserTie,
//   faMehBlank,
// } from '@fortawesome/pro-duotone-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {fad} from '@fortawesome/pro-duotone-svg-icons'

library.add(fad);
library.add(
    faClock,
    faSortUp,
    faSortDown,
    faSquare,
    faCheckSquare,
    faCircle,
    faCheckCircle,
    faMinusCircle,
    faPlusCircle,
    faInfoCircle,
    faTimes,
    faArrowsAltV,
    faEnvelope,
    faBold,
    faItalic,
    faUnderline,
    faStrikethrough,
    faLink,
    faUnlink,
    faExclamationTriangle,
    faCheck,
    faAngleLeft,
    faAngleRight,
    faCalendarTimes,
    faSave,
    faCcVisa,
    faCcStripe,
    faCcMastercard
)

Vue.component('icon', FontAwesomeIcon);
